import { useFormContext } from 'react-hook-form';

import { FormControl, FormField, FormItem } from '@crossnokaye/ux-common';

import {
  DeviceTypeDetectionVariant,
  useDeviceTypeDetection,
} from '@/ux-common/hooks/use-device-type-detection/use-device-type-detection';

import { DefrostScheduleBaseCellProps } from './defrost-schedule.types';
import { DefrostScheduleEventDayDropdown } from './defrost-schedule-event-days-dropdown';
import { DefrostScheduleEventDayMobileMenu } from './defrost-schedule-event-days-mobile-menu';
import { DefrostTableCell } from './defrost-table-cell';

export const DefrostScheduleEventDaysCell: React.FC<DefrostScheduleBaseCellProps> = ({ index }) => {
  const { control } = useFormContext();
  const { isMobile } = useDeviceTypeDetection({ variant: DeviceTypeDetectionVariant.DeviceOnly });
  const EventDaysField = isMobile
    ? DefrostScheduleEventDayMobileMenu
    : DefrostScheduleEventDayDropdown;

  return (
    <DefrostTableCell>
      {(disabledByPermissions) => (
        <FormField
          control={control}
          name={`defrostSchedule.${index}.eventDays`}
          render={({ field, fieldState: { error } }) => (
            <FormItem className="flex flex-col">
              <FormControl>
                <EventDaysField
                  disabled={disabledByPermissions}
                  error={error?.message}
                  onChange={field.onChange}
                  values={field.value}
                />
              </FormControl>
            </FormItem>
          )}
        />
      )}
    </DefrostTableCell>
  );
};
